import { Color, Spacing } from '@persona-id/design-tokens';
import { Children, ReactNode } from 'react';
import styled from 'styled-components';

import Card from 'design-system/components/Card';

const NonCarded = styled.section`
  > h6,
  > h6:first-child {
    padding: ${Spacing[4]} 0;
    margin: ${Spacing[4]} 0;
  }

  div[role='table'] {
    border-width: 1px 1px 0 1px;
    border-style: solid;
    border-color: ${Color.CoreSlate100};
  }

  div[role='columnheader'] {
    border-bottom: 1px solid ${Color.CoreSlate100};
  }

  hr {
    margin-top: ${Spacing[2]};
    margin-bottom: ${Spacing[2]};
  }

  margin-bottom: ${Spacing[4]};
`;

interface ReportResultLayoutProps {
  children: ReactNode;
  multiCardFormat: boolean;
  dataTestKey?: string;
}

const ReportResultLayout = ({
  children,
  dataTestKey,
  multiCardFormat = false,
}: ReportResultLayoutProps) => {
  return (
    <>
      {Children.toArray(children).map((child, index) => {
        return multiCardFormat ? (
          <Card
            key={index}
            data-test={`report-details__${dataTestKey ? `${dataTestKey}-` : ''}card-${index}`}
          >
            <Card.Body>{child}</Card.Body>
          </Card>
        ) : (
          <NonCarded key={index}>{child}</NonCarded>
        );
      })}
    </>
  );
};

export default ReportResultLayout;
